import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Formik, Form as FormikForm } from "formik";
import { Button } from "react-bootstrap";
import { FaEnvelope, FaUserCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { authApi } from "../api/services";
import { getErrorMessage } from "../api/client";
import FormField from "../components/forms/FormField";
import { forgotPasswordSchema } from "../validation/schemas";
import "./Login.css";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";

const ForgotPassword = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <main className="auth-page">
      <Seo {...PAGE_SEO.forgotPassword} />
      <section className="auth-card">
        <div className="auth-left">
          <span className="auth-badge">Account recovery</span>
          <h1>Reset your password</h1>
          <p>
            Enter the email address linked to your account and we&apos;ll send
            you a secure link to choose a new password.
          </p>
        </div>

        {submitted ? (
          <div className="auth-form">
            <div className="auth-icon">
              <FaEnvelope />
            </div>
            <h2>Check your email</h2>
            <p className="auth-help-text">
              If an account exists for that email, you will receive a password
              reset link shortly. The link expires after a limited time for
              security.
            </p>
            <p className="auth-help-text">
              Didn&apos;t receive it? Check your spam folder or try again in a
              few minutes.
            </p>
            <Link to="/login" className="auth-btn btn btn-primary">
              Back to login
            </Link>
          </div>
        ) : (
          <Formik
            initialValues={{ email: "" }}
            validationSchema={forgotPasswordSchema}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const res = await authApi.forgotPassword({ email: values.email });
                toast.success(
                  res.data.message ||
                    "If an account exists for that email, you will receive a reset link shortly."
                );
                setSubmitted(true);
              } catch (error) {
                toast.error(
                  getErrorMessage(error, "Could not process password reset request")
                );
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting }) => (
              <FormikForm className="auth-form" noValidate>
                <div className="auth-icon">
                  <FaUserCircle />
                </div>

                <h2>Forgot password</h2>

                <FormField
                  name="email"
                  type="email"
                  label="Email Address"
                  labelIcon={<FaEnvelope />}
                  placeholder="Enter your account email"
                  autoComplete="email"
                />

                <Button type="submit" className="auth-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Send reset link"}
                </Button>

                <p className="auth-switch">
                  Remember your password? <Link to="/login">Back to login</Link>
                </p>
              </FormikForm>
            )}
          </Formik>
        )}
      </section>
    </main>
  );
};

export default ForgotPassword;
